/** Landing: full-bleed hero art with the ways in (students join; teachers run the class; anyone plays solo). */
import * as motion from 'motion/react-m';
import { useSession } from '../net/session';
import { href } from '../router';
import { Icon } from '../ui/Icon';
import { Picture } from '../ui/Picture';
import { useReducedMotion } from '../ui/hooks';

export function Landing() {
  const { student, teacher } = useSession();
  const reduce = useReducedMotion();
  const rise = (delay: number) =>
    reduce ? {} : { initial: { opacity: 0, y: 14 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.6, delay, ease: [0.2, 0.8, 0.2, 1] as const } };
  return (
    <main className="landing" id="main">
      <Picture id="hero-t0-situation-room" alt="" className="landing__art" priority />
      <div className="landing__shade" aria-hidden />
      <div className="landing__content">
        <motion.p className="eyebrow" {...rise(0.05)}>
          A classroom world-affairs simulation
        </motion.p>
        <motion.h1 className="landing__title" {...rise(0.12)}>
          Sovereign
        </motion.h1>
        <motion.p className="landing__tagline" {...rise(0.2)}>
          Eight nations. One shared planet. Lead yours well.
        </motion.p>
        <motion.div className="landing__actions" {...rise(0.3)}>
          {student ? (
            <a className="btn btn--primary btn--lg" href={href('play')}>
              <Icon name="arrow_right" size={20} />
              <span className="btn__label">Continue as {student.name}</span>
            </a>
          ) : (
            <a className="btn btn--primary btn--lg" href={href('join')}>
              <Icon name="users" size={20} />
              <span className="btn__label">Join your class</span>
            </a>
          )}
          <a className="btn btn--secondary btn--lg" href={teacher ? href('teacher', 'console') : href('teacher')}>
            <Icon name="key" size={20} />
            <span className="btn__label">{teacher ? `Teacher console: ${teacher.className}` : 'Teacher'}</span>
          </a>
          <a className="btn btn--secondary btn--lg" href={href('solo')}>
            <Icon name="play" size={20} />
            <span className="btn__label">Play solo</span>
          </a>
        </motion.div>
        {student && (
          <motion.p className="landing__switch" {...rise(0.38)}>
            Not {student.name}? <a href={href('join')}>Join as someone else</a>
          </motion.p>
        )}
      </div>
    </main>
  );
}
